module.exports = __webpack_public_path__ + "static/media/01_tn.1753a127.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/01_tn.jpg
// module id = 139
// module chunks = 0